/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from "react";
import { getImage, isExcel } from "utils";
import { ReactComponent as MinusIcon } from "icons/minus-grey.svg";
import { ReactComponent as PlusIcon } from "icons/plus-grey.svg";
import Dropdown, {
  dropdownTypes,
} from "@visiblethread/react-components/dist/components/Dropdown";
import ButtonsDropdownOption from "@visiblethread/react-components/dist/components/Dropdown/ButtonsDropdownOption";
import { buttonVariants } from "@visiblethread/react-components/dist/components/Button";
import Gradient from "components/Gradient";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { getDictionaries } from "slices/dictionarySearch/actions/categories";
import {
  setDocExpandState,
  setDocumentCheckState,
} from "slices/dictionarySearch/dictionarySearchSlice";
import infoIcon from "icons/info.svg";
import { checkedTypes } from "constants/types";
import Checkbox from "@visiblethread/react-components/dist/components/Checkbox";
import { getDropdownTitle } from "utils/dictionarySearch";
import { TooltipTrigger } from "@visiblethread/react-components/dist/components/Tooltip";

const infoIconDiv = () => (
  <div className="gradient__info">
    <TooltipTrigger content="This file contains no text">
      <img src={infoIcon} alt="info" />
    </TooltipTrigger>
  </div>
);

const Document = ({ doc, maxOccurrences }) => {
  const dispatch = useDispatch();
  const getExpandCollapseIcon = () => {
    const props = {
      width: 8,
      height: 8,
      className: "plus_minus_icon",
    };
    return doc.expanded ? <MinusIcon {...props} /> : <PlusIcon {...props} />;
  };
  const handleExpand = () => {
    dispatch(setDocExpandState(doc.id));
  };

  const size = () =>
    isExcel(doc.name) ? (
      <span>{`${doc.paragraphCount} rows`}</span>
    ) : (
      <span>{`${doc.wordCount} words`}</span>
    );

  const handleCheck = () => {
    const newState =
      doc.checkState === undefined ||
      doc.checkState === checkedTypes.EMPTY ||
      doc.checkState === checkedTypes.INDETERMINATE
        ? checkedTypes.CHECKED
        : checkedTypes.EMPTY;
    dispatch(setDocumentCheckState({ checkState: newState, docId: doc.id }));
  };

  const documentName = (docName) => (
    <TooltipTrigger content={docName} delay={800}>
      <span>{docName}</span>
    </TooltipTrigger>
  );

  return (
    <div
      className={`document${
        doc.occurrences === 0 ||
        (!isExcel(doc.name) && doc.wordCount === 0) ||
        (isExcel(doc.name) && doc.paragraphCount === 0)
          ? " greyed"
          : ""
      }`}
      data-testid="document"
    >
      <div>
        <Checkbox
          state={
            doc.checkState && doc.occurrences > 0
              ? doc.checkState
              : checkedTypes.EMPTY
          }
          handleChange={handleCheck}
          disabled={doc.occurrences === 0}
          id="category_cb"
          value="category_cb"
        />
        <span onClick={handleExpand}>
          <img src={getImage(doc.name)} alt="doc-img" />
          {documentName(doc.name)}
          <div>{getExpandCollapseIcon()}</div>
        </span>
      </div>
      <div>
        <Dropdown
          type={dropdownTypes.buttons}
          propsObject={{
            button: <span>{doc.dictionary.name}</span>,
            title: getDropdownTitle(
              doc.dictionary.name,
              doc.dictionary.description
            ),
            options: [
              <ButtonsDropdownOption
                key="change"
                content="Change Dictionary"
                onClick={() => {
                  dispatch(getDictionaries(doc.id));
                }}
              />,
              <ButtonsDropdownOption
                key="goTo"
                content="Go To Dictionary"
                onClick={() => {
                  window.location.href = `/dictionaries/#/${doc.dictionary.id}`;
                }}
              />,
              <ButtonsDropdownOption
                key="changeMultiple"
                content="Apply Dictionary to All Docs"
                onClick={() => {
                  dispatch(getDictionaries());
                }}
              />,
            ],
            buttonVariant: buttonVariants.borderless,
          }}
        />
      </div>
      {size()}
      {(!isExcel(doc.name) && doc.wordCount > 0) ||
      (isExcel(doc.name) && doc.paragraphCount) ? (
        <Gradient content={doc.occurrences} maxOccurrences={maxOccurrences} />
      ) : (
        infoIconDiv()
      )}
    </div>
  );
};

export default Document;

Document.propTypes = {
  doc: PropTypes.shape({
    id: PropTypes.number,
    expanded: PropTypes.bool,
    name: PropTypes.string,
    checkState: PropTypes.oneOf([
      checkedTypes.CHECKED,
      checkedTypes.EMPTY,
      checkedTypes.INDETERMINATE,
    ]),
    dictionary: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string,
    }),
    wordCount: PropTypes.number,
    paragraphCount: PropTypes.number,
    occurrences: PropTypes.number,
  }),
  maxOccurrences: PropTypes.number,
};
